import type React from 'react';
import { Breadcrumbs } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import Styles from './Page.module.scss';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { DealEditor } from '~/components/common/deals/new/DealEditor';
import { PATH } from '~/pages/deals';

export const Page: React.FC = () => (
  <DefaultV2>
    <div className={Styles.PageTop}>
      <Breadcrumbs
        items={[
          { label: '案件一覧', as: Link, href: PATH },
          { label: '案件追加' }
        ]}
      />
      <h1 className={Styles.Title}>案件追加</h1>
    </div>
    <DealEditor />
  </DefaultV2>
);
